import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import { ChartData } from "./types";

interface KPICardProps {
  data: ChartData;
}

const kpiCardSx = {
  border: "1px solid var(--color-border)",
  borderRadius: "var(--radius-sm)",
  p: "var(--sp-2) var(--sp-3)",
  bgcolor: "var(--color-washi)",
  boxShadow: "none",
};

const kpiValueSx = {
  display: "block",
  fontSize: "var(--fs-18)",
  fontWeight: "var(--fw-bold)",
  color: "var(--color-ai)",
};

const kpiLabelSx = {
  display: "block",
  fontSize: "var(--fs-10)",
  color: "var(--color-sumi-muted)",
};

export default function KPICard({ data }: KPICardProps) {
  if (data.rows.length === 0) {
    return (
      <Box data-testid="ai-kpi" sx={kpiCardSx}>
        {data.title && (
          <Typography component="span" data-testid="ai-kpi-label" sx={kpiLabelSx}>
            {data.title}
          </Typography>
        )}
        <Typography component="span" data-testid="ai-kpi-value" sx={kpiValueSx}>
          データなし
        </Typography>
      </Box>
    );
  }

  const firstRow = data.rows[0];
  const numericKey = data.columns.find(
    (col) => typeof firstRow[col] === "number"
  );
  const value = numericKey != null ? firstRow[numericKey] : Object.values(firstRow)[0];

  return (
    <Box data-testid="ai-kpi" sx={kpiCardSx}>
      {data.title && (
        <Typography component="span" data-testid="ai-kpi-label" sx={kpiLabelSx}>
          {data.title}
        </Typography>
      )}
      <Typography component="span" data-testid="ai-kpi-value" sx={kpiValueSx}>
        {String(value ?? "")}
      </Typography>
      {numericKey && (
        <Typography component="span" data-testid="ai-kpi-label" sx={kpiLabelSx}>
          {numericKey}
        </Typography>
      )}
    </Box>
  );
}
